// data/knowledgeBase.ts
export const plexiKnowledgeBase = {
  company: {
    name: "PlexiSystem S.C.",
    nip: "5882396272",
    address: "Ks. Dr. Leona Heyke 11, 84-206 Nowy Dwór Wejherowski",
    email: "biuro@plexisystem.pl",
    phone: "884 042 107",
    website: "www.plexisystem.pl",
    description: "Specjalizujemy się w produkcji wyrobów z pleksi (PMMA) na zamówienie. Oferujemy profesjonalne cięcie laserem, frezowanie CNC, gięcie i klejenie.",
    workingHours: {
      weekdays: "8:00 - 16:00",
      saturday: "Na zamówienie",
      sunday: "Zamknięte"
    }
  },
  
  materials: {
    extruded: {
      name: "Pleksi ekstrudowana",
      description: "Tańsza opcja, idealna do zastosowań standardowych",
      properties: [
        "Dobra przezroczystość",
        "Łatwa w obróbce",
        "Ekonomiczna",
        "Grubości: 2-10mm"
      ],
      applications: [
        "Osłony ochronne",
        "Tablice informacyjne",
        "Podstawki",
        "Elementy reklamowe"
      ]
    },
    cast: {
      name: "Pleksi wylewana",
      description: "Premium jakość dla wymagających zastosowań",
      properties: [
        "Doskonała przezroczystość",
        "Wyższa odporność chemiczna",
        "Lepsza stabilność wymiarowa",
        "Grubości: 3-20mm"
      ],
      applications: [
        "Gabloty muzealne",
        "Akwaria",
        "Elementy optyczne",
        "Meble premium"
      ]
    }
  },
  
  products: {
    protectiveScreens: {
      name: "Osłony ochronne",
      variants: [
        {
          type: "Biurowa",
          sizes: ["60x80cm", "80x100cm", "100x120cm"],
          thickness: ["3mm", "4mm", "5mm"],
          priceRange: "150-400 PLN"
        },
        {
          type: "Kasowa",
          sizes: ["80x60cm", "100x80cm"],
          thickness: ["4mm", "5mm", "6mm"],
          features: ["Okienko podawcze", "Podstawa"],
          priceRange: "250-500 PLN"
        },
        {
          type: "Recepcyjna",
          sizes: ["120x80cm", "150x100cm"],
          thickness: ["5mm", "6mm", "8mm"],
          features: ["Zaokrąglone narożniki", "Stabilna podstawa"],
          priceRange: "400-800 PLN"
        }
      ]
    },
    
    displays: {
      name: "Ekspozytory i standy",
      types: [
        {
          name: "Stand na ulotki A4",
          pockets: ["1", "3", "5"],
          mounting: ["Stojący", "Ścienny"],
          priceRange: "80-250 PLN"
        },
        {
          name: "Ekspozytor na kosmetyki",
          shelves: ["3", "4", "5"],
          customizable: true,
          priceRange: "300-800 PLN"
        },
        {
          name: "Stand reklamowy",
          sizes: ["A3", "A2", "A1"],
          features: ["Podświetlenie LED opcjonalne"],
          priceRange: "200-1200 PLN"
        }
      ]
    },
    
    customProducts: {
      name: "Produkty na zamówienie",
      process: [
        "Konsultacja i wycena",
        "Projekt techniczny",
        "Akceptacja projektu",
        "Produkcja",
        "Kontrola jakości",
        "Dostawa"
      ],
      leadTime: "5-15 dni roboczych",
      minimumOrder: "Brak minimum dla produktów custom"
    }
  },
  
  services: {
    laserCutting: {
      name: "Cięcie laserowe",
      maxSize: "1600x1000mm",
      accuracy: "±0.1mm",
      materials: ["Pleksi", "Drewno", "Sklejka", "MDF"],
      pricing: "Od 1.5 PLN/mb"
    },
    
    cncMilling: {
      name: "Frezowanie CNC",
      maxSize: "2000x1500mm",
      accuracy: "±0.05mm",
      capabilities: ["Frezowanie 3D", "Grawerowanie", "Wycinanie"],
      pricing: "Od 120 PLN/h"
    },
    
    bending: {
      name: "Gięcie na gorąco",
      maxLength: "2000mm",
      angles: "Dowolne",
      radius: "Od 5mm",
      pricing: "Od 50 PLN/zgięcie"
    },
    
    gluing: {
      name: "Klejenie",
      types: ["Rozpuszczalnikowe", "UV", "Dwuskładnikowe"],
      strength: "Połączenie niewidoczne",
      pricing: "Od 30 PLN/połączenie"
    }
  },
  
  pricing: {
    materials: {
      extruded: {
        "2mm": { clear: 80, colored: 96, perM2: true },
        "3mm": { clear: 100, colored: 120, perM2: true },
        "4mm": { clear: 130, colored: 156, perM2: true },
        "5mm": { clear: 160, colored: 192, perM2: true },
        "6mm": { clear: 190, colored: 228, perM2: true },
        "8mm": { clear: 250, colored: 300, perM2: true },
        "10mm": { clear: 310, colored: 372, perM2: true }
      },
      cast: {
        "3mm": { clear: 130, colored: 156, perM2: true },
        "4mm": { clear: 169, colored: 203, perM2: true },
        "5mm": { clear: 208, colored: 250, perM2: true },
        "6mm": { clear: 247, colored: 296, perM2: true },
        "8mm": { clear: 325, colored: 390, perM2: true },
        "10mm": { clear: 403, colored: 484, perM2: true }
      }
    },
    
    discounts: {
      volume: [
        { from: 10, to: 24, discount: 5 },
        { from: 25, to: 49, discount: 10 },
        { from: 50, to: 99, discount: 15 },
        { from: 100, to: null, discount: 20 }
      ],
      regular: "Stali klienci -10%",
      seasonal: "Promocje okolicznościowe do -30%"
    },
    
    delivery: {
      gdansk: { price: 50, time: "1-2 dni" },
      pomorskie: { price: 80, time: "1-2 dni" },
      polska: { price: 120, time: "2-3 dni" },
      courier: "DPD, InPost, własny transport"
    }
  },
  
  faq: [
    {
      q: "Jaka jest minimalna wielkość zamówienia?",
      a: "Nie ma minimalnej wartości zamówienia. Realizujemy zarówno pojedyncze sztuki jak i produkcję seryjną."
    },
    {
      q: "Czy mogę otrzymać próbkę materiału?",
      a: "Tak, oferujemy bezpłatne próbki materiałów do 10x10cm. Większe próbki są płatne."
    },
    {
      q: "Jak długo trwa realizacja zamówienia?",
      a: "Standardowe produkty: 2-5 dni roboczych. Produkty na zamówienie: 5-15 dni roboczych w zależności od złożoności."
    },
    {
      q: "Czy oferujecie montaż?",
      a: "Tak, oferujemy profesjonalny montaż na terenie Trójmiasta. Cena ustalana indywidualnie."
    },
    {
      q: "Jakie formy płatności akceptujecie?",
      a: "Przelew, gotówka, płatność przy odbiorze. Dla stałych klientów oferujemy płatność z odroczonym terminem."
    }
  ]
};